import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    disableAddress: false,
  },
  mutations: {
    SET_DISABLE_ADDRESS(state, value: boolean) {
      state.disableAddress = value
    },
  },
  actions: {
    setDisableAddress({ commit }, value: boolean) {
      commit('SET_DISABLE_ADDRESS', value)
    },
  },
  getters: {
    isDisableAddress: (state) => state.disableAddress,
  },
})
